/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Trust_NopayInputs */

const en_directory_home_trust_nopay = /** @type {(inputs: Directory_Home_Trust_NopayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Crawler Access 100%`)
};

const zh_directory_home_trust_nopay = /** @type {(inputs: Directory_Home_Trust_NopayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Crawler Access 100%`)
};

/**
* | output |
* | --- |
* | "AI Crawler Access 100%" |
*
* @param {Directory_Home_Trust_NopayInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_trust_nopay = /** @type {((inputs?: Directory_Home_Trust_NopayInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Trust_NopayInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_trust_nopay(inputs)
	return zh_directory_home_trust_nopay(inputs)
});
export { directory_home_trust_nopay as "directory.home.trust_nopay" }